/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useState } from "react";

export const IsChatInputContext = createContext<any>({
	setIsFocused: null,
	isFocused: false
})

export function IsChatInputProvider({children}: any) {
	const [isFocused, setIsFocused] = useState(false)
	return (
		<IsChatInputContext.Provider value={{isFocused, setIsFocused}}>
			{children}
		</IsChatInputContext.Provider>
	)
}
